import PricingCards from "@/components/PricingCards";

export default function PricingPage() {
  return (
    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 space-y-10" data-testid="pricing-page">
      <div className="max-w-2xl fade-up">
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-amber-700">Pricing</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mt-3">Simple plans for busy dockets.</h1>
        <p className="text-slate-600 mt-4 leading-relaxed">
          One export is one download run on a case, however many files or ZIP parts it makes. Re-running failed files is free.
        </p>
      </div>
      <PricingCards />
    </main>
  );
}
